import authenticationConstants from 'components/Authentication/constants';
import {
  UPDATE_CHAT_PARAMS, ADD_MESSAGES, SPLICE_MESSAGES, RESET_CHAT, SET_MESSAGES,
} from './actionTypes';

const { LOGOUT } = authenticationConstants;

const initialState = {};

// eslint-disable-next-line default-param-last
export function chatReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_CHAT_PARAMS: {
      const { roomId, data } = payload;
      const { [roomId]: roomState = {} } = state;
      const { messageHistory } = roomState;
      return { ...state, [roomId]: { ...roomState, ...data, messageHistory } };
    }
    case SET_MESSAGES: {
      const { roomId, data } = payload;
      const { [roomId]: roomState = {} } = state;
      return { ...state, [roomId]: { ...roomState, messageHistory: data } };
    }
    case ADD_MESSAGES: {
      const { roomId, data } = payload;
      const { [roomId]: roomState = {} } = state;
      const { messageHistory = [] } = roomState;
      return { ...state, [roomId]: { ...roomState, messageHistory: [...messageHistory, ...data] } };
    }
    case SPLICE_MESSAGES: {
      const { roomId, data: { start, deleteCount, messages } } = payload;
      const { [roomId]: roomState = {} } = state;
      const { messageHistory = [] } = roomState;
      const nextMessageHistory = [...messageHistory];
      nextMessageHistory.splice(start, deleteCount, ...(messages ?? []));
      return { ...state, [roomId]: { ...roomState, messageHistory: nextMessageHistory } };
    }
    case RESET_CHAT: {
      const roomId = payload;
      const { [roomId]: targetRoom, ...restRooms } = state;
      return restRooms;
    }
    case LOGOUT:
      return { ...initialState };
    default:
      return state;
  }
}
